import DashboardNavbar from "./DashboardNavbar";

export default DashboardNavbar;